<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="Settings"></app-breadcrumb>

        <!-- shop settings -->
        <div class="row mb-3">
            <div class="col-md-4 col-12">
                <h3>Settings</h3>
            </div>
            <template v-if="tempShopAccessStatus">
                <div class="col-md-8 col-12">
                    <ul class="nav nav-tabs nav-settings">
                        <li @click="showGeneral" class="nav-item">
                            <router-link class="nav-link" to="?general">General</router-link>
                        </li>
                        <li @click="showPasscode" class="nav-item">
                            <router-link class="nav-link" to="?passcode">Passcode</router-link>
                        </li>
                        <li @click="showBilling" class="nav-item">
                            <router-link class="nav-link" to="?billing">Billing</router-link>
                        </li>
                        <li @click="showInfo" class="nav-item">
                            <router-link class="nav-link" to="?info">Info</router-link>
                        </li>
                    </ul>
                </div>  
            </template>
        </div>

        <!-- general settings here -->
        <app-general v-if="generalTab"></app-general>
        
        <!-- passcode settings here -->
        <app-passcode v-if="passcodeTab"></app-passcode>
        
        <!-- billing settings here -->
        <app-billing v-if="billingTab"></app-billing>
        
        <!-- info settings here -->
        <app-shop-info @gotoGeneral="showGeneral" v-if="infoTab"></app-shop-info>
    </div>
</template>

<script>
import General from './settingsParts/General.vue'
import Passcode from './settingsParts/Passcode.vue'
import Breadcrumb from '../shared/Breadcrumb.vue'
import Billing from './settingsParts/Billing.vue'
import ShopInfo from './settingsParts/ShopInfo.vue'
import LayoutShop from '@/layouts/Shop.vue'
import { mapGetters } from 'vuex'

export default {
    name: "Settings",
    data() {
        return {
            generalTab: true,
            passcodeTab: false,
            billingTab: false,
            infoTab: false,
        }
    },
    methods: {
        showGeneral() {
            this.closeAllTabs()
            this.generalTab = true
        },
        showPasscode() {
            this.closeAllTabs()
            this.passcodeTab = true
        },
        showBilling() {
            this.closeAllTabs()
            this.billingTab = true
        },
        showInfo() {
            this.closeAllTabs()
            this.infoTab = true
        },
        closeAllTabs() {
            this.generalTab = false
            this.passcodeTab = false
            this.billingTab = false
            this.infoTab = false
        }
    },
    computed: {
        ...mapGetters(['tempShopAccess']),
        tempShopAccessStatus() {
            if(this.tempShopAccess && this.tempShopAccess !== null) {
                // hide other nav controls on temp-access-mode
                if(!localStorage.getItem('_t13st40q') && this.tempShopAccess){
                    // yes return false - meaning do not show settings page nav-controls
                    return false
                }
            }
            return true
        },
    },
    components: {
        appGeneral: General,
        appPasscode: Passcode,
        appBilling: Billing,
        appShopInfo: ShopInfo,
        appBreadcrumb: Breadcrumb
    },
    created() {
        // if page is reloaded, render the same page view
        if(this.$route.query.general === null){ this.showGeneral() }
        if(this.$route.query.passcode === null){ this.showPasscode() }
        if(this.$route.query.billing === null){ this.showBilling() }
        if(this.$route.query.info === null){ this.showInfo() }

        this.$emit('update:layout', LayoutShop);
    }
}
</script>